// src/pages/InvestmentAccountLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import InvestmentAccountLedgerFilters from "./components/InvestmentAccountLedgerFilters";
import InvestmentAccountLedgerTable from "./components/InvestmentAccountLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const InvestmentAccountLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.investmentAccountLedger);
  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Investment Account Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            type="text"
                            icon={<ArrowLeftOutlined />}
                            onClick={handleNavigateToReports}
                            style={{ marginRight: 8 }}
                          />
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
              Investment Account Ledger
            </Title>
            </div>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <InvestmentAccountLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <InvestmentAccountLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Investment Account Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <InvestmentAccountLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default InvestmentAccountLedger;
